import React, { Component } from 'react';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import './DateRange.css'

class DateRange extends Component {

  maxChanged = (ignore, date) => {

    var timestamp = Date.parse(date);

    if (isNaN(timestamp) === false)
    {
      this.props.onRangeChange({
        max: date,
        min: this.props.min
      });
    }
  }

  handleCommonDateChange = (event) =>
  {
    const today = new Date();

    switch (event.target.value)
    {
      case "TODAY":
        const todayEnd = new Date();
        todayEnd.setHours(23,59,59,999);

        const todayStart = new Date();
        todayStart.setHours(0,0,0,0);

        this.props.onRangeChange({
          max: todayEnd,
          min: todayStart,
          commonDate: event.target.value
        });
      break;

      case "YESTERDAY":
        const yesterday = new Date();
        const yesterdayEnd = new Date();
        const yesterdayStart = new Date();

        yesterday.setDate(today.getDate() - 1);
        yesterdayEnd.setDate(today.getDate() - 1);
        yesterdayStart.setDate(today.getDate() - 1);

        yesterdayEnd.setHours(23,59,59,999);
        yesterdayStart.setHours(0,0,0,0);

        this.props.onRangeChange({
          max: yesterdayEnd,
          min: yesterdayStart,
          commonDate: event.target.value
        });
      break;
      
      case "INLASTWEEK":
        const sevenDaysAgo = new Date();

        sevenDaysAgo.setDate(today.getDate() - 7);

        const todaEnd = new Date();
        todaEnd.setHours(23,59,59,999);
        
        this.props.onRangeChange({
          max: todaEnd,
          min: sevenDaysAgo,
          commonDate: event.target.value
        });
      break;

      case "CURRENTYEAR":

        const firstOfYear = new Date(new Date().getFullYear(), 0, 1,0,0,0,0);
        today.setHours(23,59,59,999);

        this.props.onRangeChange({
          max: null,
          min: firstOfYear,
          commonDate: event.target.value
        });
      break;

      case "PRIORYEAR":

        const firstOfPriorYear = new Date(new Date().getFullYear() - 1, 0, 1, 0, 0, 0, 0);
        const endOfPriorYear = new Date(new Date().getFullYear() - 1, 11, 31, 23, 59, 59, 999);

        this.props.onRangeChange({
          max: endOfPriorYear,
          min: firstOfPriorYear,
          commonDate: event.target.value
        });
      break;

      default:
    }

   }

  minChanged = (ignore, date) => {
    var timestamp = Date.parse(date);

    if (isNaN(timestamp) === false)
    {
      this.props.onRangeChange({
        min: date,
        max: this.props.max
      });
    }

  }

  render() {
    const today = new Date();
    const yesterday = new Date();
    const tomorrow = new Date();
    yesterday.setDate(today.getDate() - 1);
    tomorrow.setDate(today.getDate() + 1);

    let minDate = (
      <KeyboardDatePicker
        className="date-filter"
        name="minDate"
        firstDayOfWeek={0}
        format="MM/dd/yyyy"
        value = {(this.props.min) ? new Date(this.props.min) : null }
        maxDate = { (this.props.max) ? new Date(this.props.max) : yesterday }
        label={this.props.minLabel}
        onChange={this.minChanged}
        locale="en-US"
        textFieldStyle={{width: "50px"}}
        />
      )

    let maxDate = (
      <KeyboardDatePicker
        className="date-filter"
        name="maxDate"
        format="MM/dd/yyyy"
        firstDayOfWeek={0}
        value = { (this.props.max) ? new Date(this.props.max) : null }
        maxDate = {tomorrow}
        minDate = {new Date(this.props.min)}
        label={this.props.maxLabel}
        onChange={this.maxChanged}
        locale="en-US"
        textFieldStyle={{width: "50px"}}
        />
      )

    return (
        <div className="filter-item filter-item-date-range">
        <FormControl className="date-filter-dropdown">
          <Select style={{color: "#fff"}}
            value={this.props.commonDate}
            onChange={this.handleCommonDateChange} >
            <MenuItem value="TODAY">Today</MenuItem>
            <MenuItem value="YESTERDAY">Yesterday</MenuItem>
            <MenuItem value="INLASTWEEK">In Last Week</MenuItem>
            <MenuItem value="CURRENTYEAR">Current Year</MenuItem>
            <MenuItem value="PRIORYEAR">Prior Year</MenuItem>
          </Select>
        </FormControl>
         <MuiPickersUtilsProvider utils={DateFnsUtils}>
          {minDate}<br/>
          {maxDate}
          </MuiPickersUtilsProvider>
        </div>
    );
  }

}

export default DateRange;
